// ArchiveManagement.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Archive, ArrowRight, Construction, Filter, Trash2, SortAsc } from 'lucide-react';

const ArchiveManagement = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-3">
              <Archive className="h-8 w-8 text-purple-600" />
              <h1 className="text-2xl font-bold text-gray-900">إدارة الأرشيف</h1>
            </div>
            <button 
              onClick={goBack}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
            >
              <ArrowRight size={16} />
              العودة للرئيسية
            </button>
          </div>

          {/* Description */}
          <div className="bg-purple-50 border-r-4 border-purple-400 p-6 rounded-lg mb-6">
            <div className="flex items-center">
              <Archive className="h-6 w-6 text-purple-600 ml-3" />
              <div>
                <h2 className="text-lg font-semibold text-purple-800 mb-2">
                  إدارة الأرشيف الشاملة
                </h2>
                <p className="text-purple-700 leading-relaxed">
                  هذه الصفحة مخصصة لإدارة الأرشيف وحذف وفلترة الأرشيف كاملاً.
                  يمكنك تحديد نطاق معين وعرض الأسماء بشكل أبجدي لإدارة أفضل للبيانات المؤرشفة.
                </p>
              </div>
            </div>
          </div>

          {/* Under Development Message */}
          <div className="bg-amber-50 border-r-4 border-amber-400 p-6 rounded-lg">
            <div className="flex items-center">
              <Construction className="h-8 w-8 text-amber-600 ml-3" />
              <div>
                <h2 className="text-lg font-semibold text-amber-800 mb-2">
                  صفحة تحت التطوير
                </h2>
                <p className="text-amber-700 leading-relaxed">
                  سيتم إضافة الميزات التالية قريباً:
                </p>
                <ul className="list-disc list-inside mt-3 text-amber-700 space-y-1">
                  <li>عرض جميع البيانات المؤرشفة</li>
                  <li>فلترة الأرشيف حسب التاريخ والنوع</li>
                  <li>ترتيب الأسماء أبجدياً</li>
                  <li>تحديد نطاق زمني معين للأرشيف</li>
                  <li>حذف مجموعي للبيانات المؤرشفة</li>
                  <li>استعادة البيانات من الأرشيف</li>
                  <li>نسخ احتياطية من الأرشيف</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Placeholder Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <div className="flex items-center gap-2 mb-2">
                <Filter className="h-5 w-5 text-blue-600" />
                <h3 className="font-semibold text-blue-800">فلترة الأرشيف</h3>
              </div>
              <p className="text-blue-600 text-sm">فلترة البيانات المؤرشفة حسب معايير مختلفة</p>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <div className="flex items-center gap-2 mb-2">
                <SortAsc className="h-5 w-5 text-green-600" />
                <h3 className="font-semibold text-green-800">الترتيب الأبجدي</h3>
              </div>
              <p className="text-green-600 text-sm">عرض الأسماء مرتبة أبجدياً لسهولة البحث</p>
            </div>
            
            <div className="bg-red-50 p-4 rounded-lg border border-red-200">
              <div className="flex items-center gap-2 mb-2">
                <Trash2 className="h-5 w-5 text-red-600" />
                <h3 className="font-semibold text-red-800">الحذف المجموعي</h3>
              </div>
              <p className="text-red-600 text-sm">حذف مجموعات من البيانات المؤرشفة بأمان</p>
            </div>
          </div>

          {/* Warning Section */}
          <div className="bg-red-50 border-r-4 border-red-400 p-6 rounded-lg mt-6">
            <div className="flex items-center">
              <Trash2 className="h-6 w-6 text-red-600 ml-3" />
              <div>
                <h3 className="text-lg font-semibold text-red-800 mb-2">
                  تحذير مهم
                </h3>
                <p className="text-red-700">
                  إدارة الأرشيف تتضمن عمليات حساسة قد تؤثر على البيانات التاريخية.
                  يرجى الحذر عند استخدام هذه الميزات والتأكد من إنشاء نسخ احتياطية قبل أي عملية حذف.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchiveManagement;